// Format options
export const formatOptions = [
  { value: 'Spatial', display: '60° Spatial Video (MV-HEVC)', display_short: 'Spatial', sort_order: 2 },
  { value: 'Mono180', display: '180° Mono', display_short: '180°', sort_order: 3 },
  { value: 'Stereo180SideBySide', display: '180° Stereo (Side-by-side)', display_short: '180°', sort_order: 4 },
  { value: 'Stereo180', display: '180° Stereo (MV-HEVC)', display_short: '180°', sort_order: 5 },
  { value: 'AppleImmersive', display: '180° Apple Immersive Video (AIVU)', display_short: 'AIV', sort_order: 6 },
  { value: 'Mono360', display: '360° Mono', display_short: '360°', sort_order: 7 },
  { value: 'Stereo360TopBottom', display: '360° Stereo (Top & bottom)', display_short: '360°', sort_order: 8 },
  { value: 'Stereo360', display: '360° Stereo (MV-HEVC)', display_short: '360°', sort_order: 9 },
  { value: 'Other', display: 'Other', display_short: '2D', sort_order: 1 }
];

// Category options
export const categoryOptions = [
  { value: 'Documentary', display: 'Documentary' },
  { value: 'Fiction', display: 'Fiction' },
  { value: 'Music', display: 'Music' },
  { value: 'Sports', display: 'Sports' },
  { value: 'Other', display: 'Other' }
];

// Motion options
export const motionOptions = [
  { value: 'Still', display: 'Still' },
  { value: 'LightMotion', display: 'Light Motion' },
  { value: 'IntenseMotion', display: 'Intense Motion' }
];

// Content Rating options
export const contentRatingOptions = [
  { value: 'Everyone', display: 'Everyone' },
  { value: 'Everyone10Plus', display: 'Everyone 10+' },
  { value: 'Teen', display: 'Teen' },
  { value: 'Mature17Plus', display: 'Mature 17+' },
  { value: 'AdultOnly18Plus', display: 'Adults Only 18+' },
  { value: 'RatingPending', display: 'Rating Pending' },
  { value: 'RatingPending17Plus', display: 'Rating Pending 17+' }
];

// Stream Status options
export const streamStatusOptions = [
  { value: 'NotStarted', display: 'Standby', class: 'not-started', title: 'A video file was uploaded but stream encoding has not started', show_progress: false, sort_order: 1 },
  { value: 'Queued', display: 'Queued', class: 'queued', title: 'The video file is queued for stream encoding', show_progress: false, sort_order: 2 },
  { value: 'InProgress', display: 'Encoding', class: 'in-progress', title: 'Stream encoding is in progress', show_progress: true, sort_order: 3 },
  { value: 'Completed', display: 'Live', class: 'completed', title: 'Stream is live', show_progress: false, sort_order: 4 },
  { value: 'Failed', display: 'Failed', class: 'failed', title: 'Stream encoding failed', show_progress: false, sort_order: -1 }
];

// Visibility options
export const visibilityOptions = [
  { value: 'Public', display: 'Public' },
  { value: 'TrailerOnly', display: 'Trailer Only' },
  { value: 'MetadataOnly', display: 'Metadata Only' },
  { value: 'Private', display: 'Private' }
];

// Review Status options
export const reviewStatusOptions = [
  { value: 'Draft', display: 'Draft' },
  { value: 'ReadyToSubmit', display: 'Ready to Submit' },
  { value: 'WaitingForReview', display: 'Waiting for Review' },
  { value: 'UnderReview', display: 'Under Review' },
  { value: 'NeedsRevision', display: 'Needs Revision' },
  { value: 'Approved', display: 'Approved' }
];

// Display helper functions
export const getCategoryDisplay = (value) => categoryOptions.find(opt => opt.value === value)?.display || value;
export const getFormatDisplay = (value) => formatOptions.find(opt => opt.value === value)?.display || value;
export const getFormatDisplayShort = (value) => formatOptions.find(opt => opt.value === value)?.display_short || value;
export const getFormatSortOrder = (value) => formatOptions.find(opt => opt.value === value)?.sort_order || 0;
export const getContentRatingDisplay = (value) => contentRatingOptions.find(opt => opt.value === value)?.display || value;
export const getStreamStatusDisplay = (value) => streamStatusOptions.find(opt => opt.value === value)?.display || 'Unknown';
export const getStreamStatusShowProgress = (value) => streamStatusOptions.find(opt => opt.value === value)?.show_progress || false;
export const getStreamStatusClass = (value) => streamStatusOptions.find(opt => opt.value === value)?.class || 'unknown';
export const getStreamStatusTitle = (value) => streamStatusOptions.find(opt => opt.value === value)?.title || 'Unknown stream status value: ' + value;
export const getStreamStatusSortOrder = (value) => streamStatusOptions.find(opt => opt.value === value)?.sort_order || 0;
export const getMotionDisplay = (value) => motionOptions.find(opt => opt.value === value)?.display || value;
export const getVisibilityDisplay = (value) => visibilityOptions.find(opt => opt.value === value)?.display || value;
export const getReviewStatusDisplay = (value) => reviewStatusOptions.find(opt => opt.value === value)?.display || value;

// Default form data
export const getDefaultVideoFormData = () => ({
  title: '',
  channel_id: '',
  review: 'Draft',
  visibility: 'Private',
  logline: '',
  series_id: null,
  season_id: null,
  episode_number: null,
  description: '',
  duration: null,
  format: '',
  category: '',
  motion_amount: '',
  languages: '',
  subtitles: '',
  awards: '',
  content_rating: '',
  video_file_id: null,
  trailer_file_id: null,
  banner_url: '',
  poster_url: '',
  thumbnail_url: '',
  screenshot1_url: '',
  screenshot2_url: '',
  screenshot3_url: '',
  release_date: '',
  avail_start_date: '',
  avail_end_date: '',
  production_company: '',
  directors: '',
  writers: '',
  starring: ''
});
